import { FieldModel } from '../field-model';

export class CodelistModel extends FieldModel<string> {
  private _codeListId: string;
  private _codeList: { id: string; label: string }[];
  private _isCodeField = false;
  private _isAutoComplete: boolean;

  get codeListId(): string {
    return this._codeListId;
  }

  set codeListId(id: string) {
    this._codeListId = id;
  }

  get codeList(): { id: string; label: string }[] {
    return this._codeList;
  }

  set codeList(value: { id: string; label: string }[]) {
    this._codeList = value;
  }

  get isCodeField(): boolean {
    return this._isCodeField;
  }

  set isCodeField(value: boolean) {
    this._isCodeField = value;
  }

  get isAutoComplete(): boolean {
    return this._isAutoComplete;
  }

  set isAutoComplete(value: boolean) {
    this._isAutoComplete = value;
  }
}
